<template>
  <div class="registerConsultant">
         <!-- <TheNavigationPanel/> -->
         <v-container>
            <v-toolbar flat color="#F0FFEA" height="30" >
            <v-toolbar-title style="color:#62AE32" class="headline">Edit Profile</v-toolbar-title>
        </v-toolbar>

        <v-snackbar v-model="snackbar" :timeout="4000" top color="success">
            <span>Updated profile successfully..</span> 
            <v-btn text color="white" @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-snackbar v-model="snackbar2" :timeout="4000" top color="red">
            <span>Profile Update Not Successful..</span> 
            <v-btn text color="white" @click="snackbar2 = false">Close</v-btn>
        </v-snackbar>

           <v-card class="ml-4 my-9" color="#F0FFEA" max-width="500" flat> 
                <v-row no-gutters class="mb-n4">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                    <span style="font-size:13px; color:#615D5D">Firstname</span>
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            type="text"
                            solo
                            flat
                            dense
                            v-model="firstname"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                 <v-row no-gutters class="mb-n4">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                    <span style="font-size:13px; color:#615D5D">Lastname</span>
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            
                            type="text"
                            solo
                            flat
                            dense
                            v-model="lastname"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
               
                <v-row no-gutters class="mb-n4">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Phone No</span>
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                           
                            type="text"
                            solo
                            flat
                            dense
                            v-model="contact"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n4">
                    <v-col class="mt-2" cols="12" md="4" sm="6">
                        <span style="font-size:13px; color:#615D5D">Email</span>
                        
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            type="email"
                            solo
                            flat
                            dense
                            v-model="email"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row >
                <v-row no-gutters class="mb-n4">
                    <v-col class="mt-2" cols="12" md="4" sm="6">
                        <span style="font-size:13px; color:#615D5D">Username</span>
                        
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                           readonly
                            type="text"
                            solo
                            flat
                            dense
                            v-model="username"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row >
                 <v-row no-gutters class="mb-n4">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Profile Picture</span>
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-file-input
                            accept='image/*'
                            outlined=""
                            label="Upload Picture" 
                            dense 
                            style="font-weight:bold"
                            ref="profileImgUrl"
                            color="#B1AFCE"
                            @change="onFileChange($event)"
                        ></v-file-input>
                    </v-col>
                </v-row>
                

                 <v-layout class="my-4">
                <v-spacer></v-spacer>
                <v-btn color="#08911b" :loading="loading" class="white--text btn-style" v-on:click="Update()">
                    Update Profile</v-btn>
            </v-layout>


            </v-card>

         </v-container>
  </div>
    
</template>


<script>
export default {
    components: {
    },
    data(){
        return{
            name: '',
            firstname: '',
            lastname: '',
            contact: '',
            email: '',
            username: '',
            file: '',
            loading: false,
            snackbar: false,
            snackbar2: false,
            type: "profile"

        }
    },
    methods: {
         onFileChange(e){
         this.file = e;
         },
        Update(){
        this.loading = true
        this.$store.dispatch("UpdateProfile",{
           username: this.username,
           image: this.file,
           firstname: this.firstname,
           lastname: this.lastname,
           contact: this.contact,
           email:  this.email,
           type: this.type
         })
         .then(()=>{
            this.loading= false
            this.snackbar = true;
           this.$store.dispatch("UpdateImage",this.$store.state.community.logindetails.id)
           this.$router.push('/profile')
         })
         .catch(()=>{
           this.loading= false
           this.snackbar2 = true;
           alert(error)
         });
        }
    },
    created(){
        this.firstname = this.$store.state.community.logindetails.firstname 
        this.lastname = this.$store.state.community.logindetails.lastname
        this.email = this.$store.state.community.logindetails.email
        this.username = this.$store.state.community.logindetails.consultant_id 
        this.contact = this.$store.state.community.logindetails.phone_number
    }
    
}
</script>


<style scoped>
.title-color{
  color : #62ae32;
}
.registerConsultant{
    background-color: #f0ffea;
    height: 100%;
    background-size: cover;
}

</style>